<template>
    <div>
        <b-card class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 class="modal-title">Scan QrCode Kode Kemasan</h5>
            </b-card-header>
            <b-card-body>
                <qrcode-stream @decode="onDecode"></qrcode-stream>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader';

export default {
    name: "scan-qrcode",

    props: {
        selected: {
            type: Array,
            default: () => [],
        },
    },

    components: {
        QrcodeStream,
    },

    data() {
        return {
        }
    },

    created() {
    },

    mounted() {
    },

    computed: {
    },

    watch: {
    },

    methods: {
        onDecode(value) {
            let self = this;
            if (self.selected.find((b) => b.id == parseInt(value))) {
                Toast.fire({
                    icon: 'warning',
                    title: 'Barang ' + value + ' sudah dipilih.'
                });
                return;
            }
            this.$emit('decoded', value);
        }
    },
}
</script>
